// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Division 7A Calculator Repayment Section Styles */

/* Date input container */
.date-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.date-input-container input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.calendar-button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 40px;
  background-color: #4051B5;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  cursor: pointer;
}

.calendar-icon {
  color: white;
}

/* Currency input */
.input-with-prefix {
  position: relative;
  display: flex;
  align-items: center;
}

.currency-symbol {
  position: absolute;
  left: 10px;
  color: #666;
}

.input-with-prefix input {
  padding-left: 25px;
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

/* Button styles */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s, transform 0.1s;
  font-size: 14px;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn-primary {
  background-color: #4051B5;
  color: white;
}

.btn-primary:hover {
  background-color: #354094;
}

.btn-secondary {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background-color: #e8e8e8;
}

.btn-delete {
  background-color: #f5f5f5;
  color: #d32f2f;
  border: 1px solid #ddd;
}

.btn-delete:hover {
  background-color: #ffebee;
}

.btn-add {
  background-color: #4051B5;
  color: white;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.btn-add:after {
  content: "+";
  margin-left: 5px;
  font-size: 16px;
}

.btn-add:hover {
  background-color: #354094;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

/* Repayment section styles */
.repayments-section {
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.repayments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.repayments-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.repayment-form {
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.repayment-form h3 {
  font-size: 16px;
  color: #333;
  margin-top: 0;
  margin-bottom: 15px;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.repayment-item {
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.repayment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.2s;
}

.repayment-header:hover {
  background-color: #f8f9fb;
}

.repayment-date, .repayment-amount {
  font-size: 14px;
}

.accordion-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.accordion-icon {
  color: #4051B5;
  transition: transform 0.3s;
}

.accordion-icon.expanded {
  transform: rotate(180deg);
}

.repayment-details {
  padding: 20px;
  background-color: white;
  border-top: 1px solid #e8e8e8;
}

.repayment-details h3 {
  font-size: 16px;
  color: #333;
  margin-top: 0;
  margin-bottom: 15px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/agent/Division7aCalculator.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* Division 7A Calculator Repayment Section Styles */\n\n/* Date input container */\n.date-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.date-input-container input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.calendar-button {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 40px;\n  background-color: #4051B5;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  cursor: pointer;\n}\n\n.calendar-icon {\n  color: white;\n}\n\n/* Currency input */\n.input-with-prefix {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.currency-symbol {\n  position: absolute;\n  left: 10px;\n  color: #666;\n}\n\n.input-with-prefix input {\n  padding-left: 25px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Button styles */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s, transform 0.1s;\n  font-size: 14px;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n}\n\n.btn-primary {\n  background-color: #4051B5;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #354094;\n}\n\n.btn-secondary {\n  background-color: #f5f5f5;\n  color: #333;\n  border: 1px solid #ddd;\n}\n\n.btn-secondary:hover {\n  background-color: #e8e8e8;\n}\n\n.btn-delete {\n  background-color: #f5f5f5;\n  color: #d32f2f;\n  border: 1px solid #ddd;\n}\n\n.btn-delete:hover {\n  background-color: #ffebee;\n}\n\n.btn-add {\n  background-color: #4051B5;\n  color: white;\n  padding: 8px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.btn-add:after {\n  content: \"+\";\n  margin-left: 5px;\n  font-size: 16px;\n}\n\n.btn-add:hover {\n  background-color: #354094;\n}\n\n.button-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n/* Repayment section styles */\n.repayments-section {\n  background-color: #f5f7fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.repayments-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.repayments-header h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #333;\n  font-weight: 600;\n}\n\n.repayment-form {\n  background-color: #f5f7fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.repayment-form h3 {\n  font-size: 16px;\n  color: #333;\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.repayment-item {\n  margin-bottom: 10px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n.repayment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background-color: white;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.repayment-header:hover {\n  background-color: #f8f9fb;\n}\n\n.repayment-date, .repayment-amount {\n  font-size: 14px;\n}\n\n.accordion-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.accordion-icon {\n  color: #4051B5;\n  transition: transform 0.3s;\n}\n\n.accordion-icon.expanded {\n  transform: rotate(180deg);\n}\n\n.repayment-details {\n  padding: 20px;\n  background-color: white;\n  border-top: 1px solid #e8e8e8;\n}\n\n.repayment-details h3 {\n  font-size: 16px;\n  color: #333;\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
